<template>
    <div class="chime-datepicker-popper">
        <date-picker
            v-show="pickerType == 0"
            :year="show.year"
            :month="show.month"
            :today="today"
            :current="current"
            ref="datePicker"
            @chooseDate="chooseDate"
            @openYearPicker="pickerType = 2"
            @openMonthPicker="pickerType = 1"
            @updateYearMonth="updateYearMonth"
        />
        <month-picker
            v-show="pickerType == 1"
            :year="show.year"
            :todayMonth="today.month"
            @updateYear="show.year = $event"
            @chooseMonth="chooseMonth"
        />
        <year-picker v-show="pickerType == 2" @chooseYear="chooseYear" />
    </div>
</template>
<script>
import MonthPicker from './MonthPicker';
import YearPicker from './YearPicker';
import DatePicker from './DatePicker';
export default {
    emits: ['chooseDate'],
    components: { MonthPicker, YearPicker, DatePicker },
    props: {
        date: Object //{year, month, date}
    },
    data: function() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const date = today.getDate();
        return {
            pickerType: 0, //0:datePicker, 1: monthPicker, 2: yearPicker,
            show: { year, month },
            today: { year, month, date },
            // current:{year, month, date},
            current: { year: 0, month: 0, date: 0 }
        };
    },
    methods: {
        chooseMonth(month) {
            this.show.month = month;
            this.pickerType = 0;
            this.$refs.datePicker.get42Day(this.show.year, this.show.month);
        },
        chooseYear(year) {
            this.show.year = year;
            this.pickerType = 1;
        },
        chooseDate({ year, month, date }) {
            Object.assign(this.current, { year, month, date });
            this.$emit('chooseDate', { year, month, date });
            this.pickerType = 0;
        },
        updateYearMonth({ year, month }) {
            this.show.year = year;
            this.show.month = month;
            this.$refs.datePicker.get42Day(this.show.year, this.show.month);
        }
    },
    watch: {
        date: {
            immediate: true,
            handler: function({ year, month, date }) {
                if (!(year + month + date)) {
                    return;
                }
                Object.assign(this.current, { year, month, date });
                Object.assign(this.show, { year, month });
            }
        }
    }
};
</script>
<style lang="scss">
.chime-datepicker-popper {
    // position: absolute;
    color: #606266;
    width: 292px;
    .chime-datepicker-header {
        display: flex;
        justify-content: space-between;
        margin: 12px 12px 0;
        padding-bottom: 12px;
        line-height: 30px;
        &.line {
            border-bottom: 1px solid #e4e7ed;
        }
        .title {
            font-size: 16px;
            font-weight: 500;
            padding: 0 5px;
            line-height: 30px;
            color: #606266;
            user-select: none;
            .cursor {
                cursor: pointer;
                &:hover {
                    color: var(--color-theme);
                }
            }
        }
    }
    .datepicker-btn {
        cursor: pointer;
        font-size: 12px;
        &:hover {
            color: var(--color-theme);
        }
        &.prev-prev-btn {
            transform: rotate(180deg);
        }
    }
    .chime-datepicker-table {
        font-size: 12px;
        user-select: none;
        padding: 12px;
        table {
            width: 100%;
        }
        th {
            padding: 5px;
            color: #606266;
            font-weight: 400;
            border-bottom: solid 1px #ebeef5;
        }
        td {
            cursor: pointer;
            width: 32px;
            height: 30px;
            padding: 4px 0;
            text-align: center;
            &:hover {
                color: var(--color-theme);
            }
            &.current:not(.disabled) span {
                color: #fff;
                background-color: var(--color-theme);
            }
            &.available:hover {
                color: var(--color-theme);
            }
            &.today {
                color: var(--color-theme);
                font-weight: 700;
            }
            &.prev-month,
            &.next-month {
                color: #c0c4cc;
            }
            span {
                display: block;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 50%;
                margin: auto;
            }
        }
    }
}
</style>
